import { DocumentationActions } from '~/service/analytics'
import { DocumentsGroupType } from '@mutual-services/account-documents-types'

export const translateTabNameToDocumentGroupType = (tabName: string): DocumentsGroupType => {
  switch (tabName) {
    case 'Contrato social':
      return DocumentsGroupType.ARTICLES_OF_INCORPORATION
    case 'Balanço':
      return DocumentsGroupType.BALANCE_SHEET
    case 'Outros':
      return DocumentsGroupType.ADDITIONAL
    case 'Extrato bancário':
      return DocumentsGroupType.BANK_STATEMENT
    case 'Fotos da empresa':
      return DocumentsGroupType.COMPANY_PHOTO
    case 'Vídeos da empresa':
      return DocumentsGroupType.COMPANY_VIDEO
    case 'DRE':
      return DocumentsGroupType.DRE
    case 'Imposto de renda dos sócios':
      return DocumentsGroupType.INCOME_TAX
    case 'RG/CNH dos sócios':
      return DocumentsGroupType.RG
    case 'Selfie dos sócios':
      return DocumentsGroupType.SELFIE
    case 'Simples nacional':
      return DocumentsGroupType.SIMPLES_NACIONAL
    default:
      return DocumentsGroupType.ADDITIONAL
  }
}

export const getOnDocumentationTabClickAction = (type: DocumentsGroupType): DocumentationActions => {
  switch (type) {
    case DocumentsGroupType.BALANCE_SHEET:
      return DocumentationActions.DOCUMENTATION_TAB_BALANCE_SHEET
    case DocumentsGroupType.ADDITIONAL:
      return DocumentationActions.DOCUMENTATION_TAB_ADDITIONAL
    case DocumentsGroupType.ARTICLES_OF_INCORPORATION:
      return DocumentationActions.DOCUMENTATION_TAB_ARTICLES_OF_INCORPORATION
    case DocumentsGroupType.BANK_STATEMENT:
      return DocumentationActions.DOCUMENTATION_TAB_BANK_STATEMENT
    case DocumentsGroupType.COMPANY_PHOTO:
      return DocumentationActions.DOCUMENTATION_TAB_PHOTOS
    case DocumentsGroupType.COMPANY_VIDEO:
      return DocumentationActions.DOCUMENTATION_TAB_VIDEOS
    case DocumentsGroupType.DRE:
      return DocumentationActions.DOCUMENTATION_TAB_DRE
    case DocumentsGroupType.SIMPLES_NACIONAL:
      return DocumentationActions.DOCUMENTATION_TAB_SIMPLES_NACIONAL
    default:
      return DocumentationActions.DOCUMENTATION_TAB_ADDITIONAL
  }
}

export const getOnDocumentationSaveClickAction = (type: DocumentsGroupType): DocumentationActions => {
  switch (type) {
    case DocumentsGroupType.BALANCE_SHEET:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_BALANCE_SHEET
    case DocumentsGroupType.ADDITIONAL:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_ADDITIONAL
    case DocumentsGroupType.ARTICLES_OF_INCORPORATION:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_ARTICLES_OF_INCORPORATION
    case DocumentsGroupType.BANK_STATEMENT:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_BANK_STATEMENT
    case DocumentsGroupType.COMPANY_PHOTO:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_PHOTOS
    case DocumentsGroupType.COMPANY_VIDEO:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_VIDEOS
    case DocumentsGroupType.DRE:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_DRE
    case DocumentsGroupType.SIMPLES_NACIONAL:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_SIMPLES_NACIONAL
    default:
      return DocumentationActions.SAVE_BUTTON_DOCUMENTATION_TAB_ADDITIONAL
  }
}

export const getOnDocumentationPendencyClickAction = (type: DocumentsGroupType): DocumentationActions => {
  switch (type) {
    case DocumentsGroupType.BALANCE_SHEET:
      return DocumentationActions.SOLVED_PENDENCY_BALANCE_SHEET
    case DocumentsGroupType.ADDITIONAL:
      return DocumentationActions.SOLVED_PENDENCY_ADDITIONAL
    case DocumentsGroupType.ARTICLES_OF_INCORPORATION:
      return DocumentationActions.SOLVED_PENDENCY_ARTICLES_OF_INCORPORATION
    case DocumentsGroupType.BANK_STATEMENT:
      return DocumentationActions.SOLVED_PENDENCY_BANK_STATEMENT
    case DocumentsGroupType.COMPANY_PHOTO:
      return DocumentationActions.SOLVED_PENDENCY_PHOTOS
    case DocumentsGroupType.COMPANY_VIDEO:
      return DocumentationActions.SOLVED_PENDENCY_VIDEOS
    case DocumentsGroupType.DRE:
      return DocumentationActions.SOLVED_PENDENCY_DRE
    case DocumentsGroupType.SIMPLES_NACIONAL:
      return DocumentationActions.SOLVED_PENDENCY_SIMPLES_NACIONAL
    default:
      return DocumentationActions.SOLVED_PENDENCY_ADDITIONAL
  }
}
